import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DocumentCenterResponse } from '../../shared/models/documentCenterResponse';
import { InterestLetterResponse } from '../../shared/models/interestLetterReponse';
import JSZip from 'jszip/dist/jszip';
import * as FileSaver from 'file-saver';
import { NativeDateAdapter, MatDateFormats, MatNativeDateModule } from '@angular/material/core';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule, MatDialogContent, MatDialogActions, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

interface Requests {
  value: string;
  viewValue: string;
}


export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
   dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
 },
 display: {
   dateInput: 'input',
   monthYearLabel: { year: 'numeric', month: 'numeric' },
   dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric'
   },
   monthYearA11yLabel: { year: 'numeric', month: 'long' },
 }
};

export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = date.getFullYear();
      return `${month}/${day}/${year}`;
    }
    return date.toDateString();
  }
}

@Component({
    selector: 'div.dtf-admindashboardpage',
    templateUrl: './admindashboard.component.html',
    imports: [SharedTranslateModule, SessionTimeoutComponent, MatTableModule, MatSortModule, FormsModule, MatRadioModule, ReactiveFormsModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatCheckboxModule],
    providers: [
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
    ]
})
export class AdminDashboardComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  token: string;
  brandId: string;
  contractNumber: string;
  ccanID: string;
  customerNumber: string;
  customerNumber1: string;
  loginAttempt = false;
  isLoginattempt = '';
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  titleLoaded = true;
  contractLoaded = true
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  isAdmin: string;
  adminUserType: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  dbData: any;
  public alerts: Banner;
  ContractOccurred = false;
  TitleOccurred = false;
  InterestFound = false;


  serviceErrorDesc = '';
  InterestserviceErrorDesc = '';

  toggleOpen: any;
  ciamId = sessionStorage.getItem('username');
  recAccCount = '';
  totalDue = '';

  accountDetailsRes: AccoutDetailsResponse[];
  documentCenterRes: DocumentCenterResponse[];
  interestLetterRes: InterestLetterResponse[];
  pdfByteArrays = [];
  pdfNames = [];
  tableLoaded = true;
  selectedTitle: string;
  selectedContract: string;
  accountNumber: string;
  dateRangeStart :string;
  dateRangeEnd :string;
  selectedMonth: string = '';
  selectedRequest: string = '';

  startDate: string = '';
  endDate: string = '';
  selectedDateRange: string = '';
  statementMonths: { key: string, value: string }[] = [];
  selectedRequests: Requests[] = [
    {value: 'contract copy', viewValue: 'Contract/Lease Copy'}
    // ,{value: 'title state transfer', viewValue: 'State-to-State Transfer'},
  ];
  selectedRequestsCA: Requests[] = [
    {value: 'contract copy', viewValue: 'Contract Copy'}
    // ,{value: 'title state transfer', viewValue: 'Lien Release'},
  ];

  selectedRequestsFR: Requests[] = [
    {value: 'contract copy', viewValue: 'Copie du contrat'}
    // ,{value: 'title state transfer', viewValue: 'Libération d\'intérêt'},
  ];

  minDate: Date;
  currentDate: Date;
  monthListArray = [
    { month: '1', monthAsString: 'January' },
    { month: '2', monthAsString: 'February' },
    { month: '3', monthAsString: 'March' },
    { month: '4', monthAsString: 'April' },
    { month: '5', monthAsString: 'May' },
    { month: '6', monthAsString: 'June' },
    { month: '7', monthAsString: 'July' },
    { month: '8', monthAsString: 'August' },
    { month: '9', monthAsString: 'September' },
    { month: '10', monthAsString: 'October' },
    { month: '11', monthAsString: 'November' },
    { month: '12', monthAsString: 'December' },
  ];
  

  //Interest letter changes
  selectedYear: string;
  years: any = [];

  year: number;
  lastYear: number;
  previousYear: number;
  priorYear: number;
  //For Radio Buttons
  private defaultSelected = 0
  private selection: number

  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';
  message: string;
  showmessage = false;

  //PDF 
  titledata: string;
  contractdata: string;

  base64data: string;
  pdfname: string;
  paymentFlag: boolean;
  successMessage: string = '';
  constructor(router: Router, private dtfhomepageService: DTFHomepageService, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil,public dialog: MatDialog
  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  ngAfterViewInit() {
  }


  ngOnInit() {
   console.log("admin dashboard ngOnInit called");
    const language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;

    const loginRequest = {
      userId : sessionStorage.getItem('username'),
      password : "",
      country: this.currentCountry,
      language : language,
      recaptcha : false
    };
    this.getAdminLogin(loginRequest);

    //Year Variables for Interest Letter
    this.year = new Date().getFullYear();
    this.lastYear = this.year - 1;
    this.previousYear = this.year - 2;
    this.priorYear = this.year - 3;
    this.minDate = new Date(new Date().getFullYear()-1, new Date().getMonth()-1, new Date().getDate());
    this.currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    this.years.push(this.lastYear.toString());
    this.years.push(this.previousYear.toString());
    this.years.push(this.priorYear.toString());
    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });

    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    this.dtfhomepageService.PayToggle().subscribe(res => {
      const banner = res?.[0]?.bannerEnable;
      this.paymentFlag = banner ? true : false;
      console.log('Payment Flag:', this.paymentFlag);
    });

    // const dashBoardRequest = {
    //   ciamId: this.ciamId,
    //   ciamAZCode: this.token
    // };
    // this.getDashBoardDetails(dashBoardRequest);

    //this.getAlerts();
    // this.getAccountDetailsListByUserId();
  }

 
  setData() {
    // if (this.selectedMonth && this.selectedMonth !== '') {
       // October, 2022
    if(this.selectedMonth !== null && this.selectedMonth !== ''){
      sessionStorage.setItem('statementPeriod', this.selectedMonth);
    }
    else {
      sessionStorage.setItem('startDate', this.startDate);
      sessionStorage.setItem('endDate', this.endDate);
    }
  }
  
  getAdminLogin(loginRequest) {
    // this.loginLoaded = false; //Spinner enabler
    this.auth.adminLogin(loginRequest).subscribe(res => {
        // this.loginLoaded = true;
        if (res.userValid){
          sessionStorage.setItem("username", res.userId);
          this.auth.getAuthToken().subscribe(authRes=> {
            sessionStorage.setItem("Authorization", authRes.token);
            sessionStorage.setItem("userId", authRes.userId);
          sessionStorage.setItem('adminauth', 'yes');
          sessionStorage.setItem('isAdmin',res.admin);
          sessionStorage.setItem('adminUserType',res.userType);
          sessionStorage.setItem('AdminName',res.userId);
          sessionStorage.setItem('emailAddress',res.emailAddress);

          this.agentview = sessionStorage.getItem('agentview');
          this.agentId = sessionStorage.getItem('agentID');
          this.isAdmin = sessionStorage.getItem('isAdmin');
          this.adminUserType = sessionStorage.getItem('adminUserType');
          this.brandId = sessionStorage.getItem('brandId');
          this.token = sessionStorage.getItem('ciamToken');

          this.auth.isAdminAuthenticated(); // Checks if user is authenticated
          // this.openLoginModal = false;
          // this._window.nativeWindow.location.href = this.usUrl + '/home/admindashboard';
        });
         } else if (res.userValid === false) {
          sessionStorage.removeItem('Authorization');
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('username');
      this._window.nativeWindow.location.href = this.usUrl + '/home';

          this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
            this.serviceErrorDesc = data;
           });
        } else {
         const msg = res.status.message;
         this.serviceErrorDesc =
           loginRequest.language === 'en-CA' ? msg.shortMessage_EN :
           loginRequest.language === 'fr-CA' ? msg.shortMessage_FR :
           msg.shortMessage;
        }
  });
}

  checkUrl(redirect: string) {
    if(redirect === 'mfa'){
      this.azURL =  this.usUrl + '/home/adminmfa?customerNumber='+this.customerNumber;
    }
    if(redirect === 'invoice'){
      this.azURL =  this.usUrl + '/home/admininvoice';
    }
    if(redirect === 'changepassword'){
      this.azURL =  this.usUrl + '/home/adminprofile';
    }
    if(redirect === 'admin'){
      this.azURL =  this.usUrl + '/home/adminprofile?openProfile=yes';
    }
    if(redirect === 'adminfunctions'){
      this.azURL =  this.usUrl + '/home/adminfunctions';
    }
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);  //1s
  }

  lineItemPaymentEnable() {

    const request = {
      ccanId: this.customerNumber1,
      paymentFlag: "Y"
    }

    this.auth.saveLineItemFlag(request).subscribe(res => {
      console.log(res);
      if(res){
        this.message = `This Customer Number is now enabled to do Payments by Individual line Items.`;
        this.showmessage = true;

        const logReq = {
          adminId: this.ciamId,
          actionType: 'SaveLineItemFlag',
          targetUser: this.customerNumber1,
          description: 'Line item payment enabled',
          module: 'Enable_Line_Item_Payment',
          status: 'SUCCESS'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => {

        });
      }else{
        this.message = `There is an issue in updating.`;
        this.showmessage = true;
        const logReq = {
          adminId: this.ciamId,
          actionType: 'SaveLineItemFlag',
          targetUser: this.customerNumber1,
          description: 'Line item payment enabled',
          module: 'Enable_Line_Item_Payment',
          status: 'FAILED'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => {

        });
      }
    });

  }

   lineItemPaymentDisable() {

    const request = {
      ccanId: this.customerNumber1,
      paymentFlag: "N"
    }

    this.auth.saveLineItemFlag(request).subscribe(res => {
      console.log(res);
      if(res){
        this.message = `This Customer Number is now disabled to do Payments by Individual line Items.`;
        this.showmessage = true;
        const logReq = {
          adminId: this.ciamId,
          actionType: 'SaveLineItemFlag',
          targetUser: this.customerNumber1,
          description: 'Line item payment disabled',
          module: 'Enable_Line_Item_Payment',
          status: 'SUCCESS'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => {  });
      }else{
        this.message = `There is an issue in updating.`;
        this.showmessage = true;
        const logReq = {
          adminId: this.ciamId,
          actionType: 'SaveLineItemFlag',
          targetUser: this.customerNumber1,
          description: 'Line item payment disabled',
          module: 'Enable_Line_Item_Payment',
          status: 'FAILED'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => { });
      }
    });

  }


  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }


  // getAccountDetailsListByUserId() {
  //   const accountDetailsRequest = {
  //     ciamId: this.ciamId,
  //     ciamAZCode: this.token
  //   };
  //   this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
  //     this.accountDetailsRes = res.accountdetailsList;
  //   });
  // }

  // getDashBoardDetails(dashBoardRequest) {
  //   this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
  //     this.recAccCount = res.recAccCount;
  //     this.totalDue = res.totalDue;
  //     if (this.totalDue.includes("-")) {
  //       this.totalDue = "0.00";
  //     }
  //   });
  // }

  retrieveInterestLetter(year: string) {
    this.tableLoaded = false; // Set to false initially
    console.log('Table Loaded:', this.tableLoaded);
    this.pdfByteArrays = [];
    this.pdfNames = [];

    const InterestRequest = {
      "year": year,
      "ccanID" : this.ccanID
    };
    this.auth.adminretrieveInterestLetter(InterestRequest).subscribe(res => {
      this.interestLetterRes = res;
      for (var i = 0; i < this.interestLetterRes.length; i++) {
        // If checks to load BE error messages based on language
        if (this.interestLetterRes[i].statusMessage === 'SUCCESS') {
          this.base64data = this.interestLetterRes[i].interestLetterFile;
          this.pdfname = this.interestLetterRes[i].interestLetterName;
          this.pdfByteArrays.push(this.base64data);
          this.pdfNames.push(this.pdfname);
          this.InterestFound = true;
        }
      }
      if (this.pdfByteArrays.length > 1) { //Download list as Zip
        this.downloadZip(year);
      }
      else if (this.pdfByteArrays.length === 1) {//Download Single PDF
        this.getImage();
      }
      if (!this.InterestFound) {
        this.translate.get('Errors.InterestError').subscribe((data: any) => {
          this.InterestserviceErrorDesc = data;
        });
        setTimeout(() => {
          this.InterestFound = true;
        }, 3000);  //4s
      }
      this.tableLoaded=true;
    });
  }


  public b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  getImage() {
    var blob = this.b64toBlob(this.base64data, "application/pdf");
    let a = document.createElement("a");
    document.body.appendChild(a);
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = String(this.pdfname);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }



  downloadZip(year: string) {
    var zip = new JSZip();
    this.pdfByteArrays.forEach((value, i) => {
      zip.file(this.pdfNames[i], value, { base64: true });
    });
    zip.generateAsync({ type: 'blob' }).then(function (content) {
      FileSaver.saveAs(content, "interestltr_" + year + '.zip');
    });
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  popupEnablePayments() {
    this.opendialog();
  }

  opendialog() {
      const dialogRef = this.dialog.open(enablePaymentsPopupComponent, {
        data: { }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if(!this.paymentFlag){
            this.disablePayments();
          }
          else{
            this.EnablePayments();
          }
        }
      });
    }

  EnablePayments(){
    const logReq = {
      paymentFlag:"N",
      userId:this.ciamId
    };
    this.auth.savePaymentFlag(logReq).subscribe(res => {
      this.paymentFlag= false;

      const logReq = {
        adminId: this.ciamId,
        actionType: 'EnablePayments',
        targetUser: '',
        description: 'Pay now button is enabled in user UI',
        module: 'Payments',
        status: 'SUCCESS'
      };
      this.auth.saveAdminAuditLog(logReq).subscribe(res => {
        this.successMessage = 'Changes have been saved successfully.';
      });
    });
  }
  
  disablePayments(){
    const logReq = {
      paymentFlag:"Y",
      userId:this.ciamId
    };
    this.auth.savePaymentFlag(logReq).subscribe(res => {
      this.paymentFlag= true;
      const logReq = {
        adminId: this.ciamId,
        actionType: 'DisabledPayments',
        targetUser: '',
        description: 'Pay now button is disabled in user UI',
        module: 'Payments',
        status: 'SUCCESS'
      };
      this.auth.saveAdminAuditLog(logReq).subscribe(res => {
        this.successMessage = 'Changes have been saved successfully.';
      });
    });
  }
}

@Component({
    selector: 'dialog-enable-payments',
    imports: [
        MatPaginatorModule, MatSortModule, MatTableModule, MatCheckboxModule, MatFormFieldModule, MatDialogModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatButtonModule, MatSortModule,
        MatDialogContent, MatDialogActions],
    templateUrl: 'enablePaymentPopup.component.html'
})
export class enablePaymentsPopupComponent {

  amount1: string;
  agentView: boolean = false;
  thirdParty: string;
  wasatch: boolean = false;
  paymentLineItem: string;

  constructor(
    public dialogRef: MatDialogRef<AdminDashboardComponent>, public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any  
  ) { }

  onOk() {
    this.dialogRef.close(true);  
  }

 
  onCancel() {
    this.dialogRef.close(false); 
  }


}

